import moment from "moment";
export const addZeroes = (num) => {
    // Cast as number
    var num = Number(num);
    // If not a number, return 0
    if (isNaN(num)) {
        return 0;
    }
    // If there is no decimal, or the decimal is less than 2 digits, toFixed
    if (String(num).split(".").length < 2 || String(num).split(".")[1].length <= 2) {
        num = num.toFixed(2);
    }
    // Return the number
    return num;
}

export const capitalizeWords = (str) => {
    return str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const getLatestUpdated = (data = []) => {
  if (!Array.isArray(data) || data.length === 0) return null;

  return data.reduce((latest, curr) => {
    if (!curr.updated) return latest;
    if (!latest) return curr;

    return moment(curr.updated).isAfter(latest.updated)
      ? curr
      : latest;
  }, null);
};